import { axiosInstance } from "@innoclouds/api";
import axios, { type AxiosAdapter, AxiosError, AxiosHeaders, type AxiosResponse, CanceledError, type InternalAxiosRequestConfig } from "axios";
import { askBackend, type BackendReply, encodeReply, isBackendUrl, NO_CONTENT, SAFE_METHODS } from "./transport";

const isSuccess = (status: number) => status >= 200 && status < 300;

const settle = (config: InternalAxiosRequestConfig, reply: BackendReply): AxiosResponse => {
	const { status } = reply;
	const response: AxiosResponse = {
		data: encodeReply(reply, config.responseType),
		status,
		statusText: String(status),
		headers: new AxiosHeaders({ "Content-Type": "application/json" }),
		config,
	};
	if ((config.validateStatus ?? isSuccess)(status)) return response;
	throw new AxiosError(
		`Request failed with status code ${status}`,
		status >= 500 ? AxiosError.ERR_BAD_RESPONSE : AxiosError.ERR_BAD_REQUEST,
		config,
		null,
		response,
	);
};

export const patchAxios = () => {
	const nativeAdapter = axios.getAdapter(["xhr", "fetch"]);

	const adapter: AxiosAdapter = async (config) => {
		const url = axios.getUri(config);
		const method = (config.method ?? "get").toUpperCase();
		const isBackend = isBackendUrl(url);
		if (!isBackend && SAFE_METHODS.has(method)) return nativeAdapter(config);
		if (config.signal?.aborted) throw new CanceledError(undefined, undefined, config);
		const reply = isBackend ? await askBackend(method, url, config.data) : NO_CONTENT;
		if (config.signal?.aborted) throw new CanceledError(undefined, undefined, config);
		return settle(config, reply);
	};

	axios.defaults.adapter = adapter;
	axiosInstance.defaults.adapter = adapter;
};
